import { IconButton, Menu, MenuGroup, MenuItem } from '@prenuvo/halo-foundation';

import { useReportIssue } from '@/core/report-issue';
import { FCT } from '@/i18n/locales.constant';

import { EllipsisSvg } from './ellipses-svg.component';

interface HeaderMenuProps {
  onOpenActivityLogs: () => void;
}

export function HeaderMenu({ onOpenActivityLogs }: HeaderMenuProps) {
  const { onToggleReportIssue } = useReportIssue();

  return (
    <Menu trigger={<IconButton icon={EllipsisSvg} size="sm" variant="text" />}>
      <MenuGroup>
        <MenuItem
          className={{ root: 'cursor-pointer' }}
          content={FCT.REPORTING.HEADER.MENU.ACTIVITY_LOG}
          onSelect={onOpenActivityLogs}
        />

        <MenuItem
          className={{ content: 'w-full', root: 'cursor-pointer' }}
          content={FCT.REPORTING.HEADER.MENU.REPORT_ISSUE}
          onSelect={() => onToggleReportIssue(true)}
          size="sm"
        />
      </MenuGroup>
    </Menu>
  );
}
